import * as React from "react";
import { SpinnerWrapper } from "soprasteria-ui-library";
import { useAuth } from "../../../App";
import { CheckBudgetApi } from "../../../api/CheckBudgetApi";
import { ICheckBudget } from "../../../models/ICheckBudget";
import { setMessage } from "../../../helpers/MessageHelper";
import { CheckBudgetTable } from "./CheckBudgetTable";


export const CheckBudgets: React.FunctionComponent<{}> = () => {
    const auth = useAuth();
    const api = new CheckBudgetApi(auth);

    const [isLoadingCheckBudgets, setIsLoadingCheckBudgets] = React.useState<boolean>(false);
    const [checkBudgets, setCheckBudgets] = React.useState<ICheckBudget[]>([]);
    const [errorMessage, setErrorMessage] = React.useState<string>("");

    React.useEffect(() => {
        setIsLoadingCheckBudgets(true);

        api.getActiveCheckBudgets((data: ICheckBudget[]) => {
            setCheckBudgets(data);
            setIsLoadingCheckBudgets(false);
        }, (message) => {
            const newErrorMessage = setMessage(message, errorMessage);
            setErrorMessage(newErrorMessage);
        });
    }, []);

    return (
        <SpinnerWrapper isLoading={isLoadingCheckBudgets}>
            <section className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col">
                            <h1>Vårderbjudanden att besluta</h1>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <p>Maximalt antal vårderbjudanden att besluta för år tre justeras löpande med maximalt +- 10% av utfallets avvikelse från budget för år ett och två så att totalbudget för avtalstiden blir korrekt</p>
                    <CheckBudgetTable checkBudgets={checkBudgets} />
                </div>
            </section>
        </SpinnerWrapper>
    )
}